// extracted by mini-css-extract-plugin
export default {"container":"NG","productarea":"OG","btn":"PG","promowrapper":"QG","upsellarea":"RG","subtitle":"SG","system":"TG","desc":"UG","cardswrap":"VG","cards":"WG","squareloadingcontainer":"XG","squareloading33":"YG"};
    if(module.hot) {
      // 1726593106325
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  